import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface AuthContextType {
  token: string | null;
  role: string | null;
  name: string | null; // Added Name
  login: (token: string, role: string, name: string) => void; // Updated Login signature
  logout: () => void;
  isAuthenticated: boolean;
}

const AdminAuthContext = createContext<AuthContextType | null>(null);

export const AdminAuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [token, setToken] = useState<string | null>(localStorage.getItem("adminToken"));
  const [role, setRole] = useState<string | null>(localStorage.getItem("adminRole"));
  const [name, setName] = useState<string | null>(localStorage.getItem("adminName")); // Name State
  const navigate = useNavigate();

  useEffect(() => {
    const storedToken = localStorage.getItem("adminToken");
    const storedRole = localStorage.getItem("adminRole");
    const storedName = localStorage.getItem("adminName");
    if (storedToken && storedRole) {
      setToken(storedToken);
      setRole(storedRole);
      setName(storedName);
    }
  }, []);

  const login = (newToken: string, newRole: string, newName: string) => {
    localStorage.setItem("adminToken", newToken);
    localStorage.setItem("adminRole", newRole);
    localStorage.setItem("adminName", newName); // Save Name
    setToken(newToken);
    setRole(newRole);
    setName(newName);
    navigate("/homes-back/dashboard");
  };

  const logout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminRole");
    localStorage.removeItem("adminName");
    setToken(null);
    setRole(null);
    setName(null);
    navigate("/homes-back");
  };

  return (
    <AdminAuthContext.Provider value={{ token, role, name, login, logout, isAuthenticated: !!token }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);
  if (!context) throw new Error("useAdminAuth must be used within AdminAuthProvider");
  return context;
};